import { CardColor, Shop } from "@/types/v2";
import { ColorList } from "@/components/Colors/ColorList";
import { useMemo } from "react";
import { DEFAULT_COLORS } from "@/lib/const";
import { shop as shopRepository } from "@/repositories/shop";
import { showErrorToast, showSuccessToast } from "@/lib/toast";

type ColorConfigurationSettingsProps = {
  shopData: Shop;
  syncWithSource: () => void;
};
export const ColorConfigurationSettings = ({
  shopData,
  syncWithSource,
}: ColorConfigurationSettingsProps) => {
  const shopId = useMemo(() => shopData.id, [shopData]);

  const colorsArray = useMemo(() => {
    return shopData?.cardConfig?.cardColors ?? DEFAULT_COLORS;
  }, [shopData]);

  const handleSaveColor = async ({
    id,
    description: newDescription,
    title: newTitle,
  }: CardColor) => {
    if (!shopId || !shopData?.cardConfig) return;

    if (shopData.cardConfig.cardColors) {
      const updatedCardColors = shopData.cardConfig.cardColors.map((color) =>
        color.id === id
          ? { ...color, title: newTitle, description: newDescription }
          : color
      );

      // Update the card colors
      shopRepository
        .updateCardColors(shopId, updatedCardColors)
        .then(() => {
          showSuccessToast(
            "Color Updated",
            "The color details have been updated successfully."
          );
          syncWithSource();
        })
        .catch((err: Error) => {
          console.error("An error occurred updating colors: ", err);
          showErrorToast(
            "Card Color Failed to Update",
            `An error occurred updating card colors: ${err.message}`
          );
        });
    } else {
      const updatedCardColors = DEFAULT_COLORS.map((color) =>
        color.id === id
          ? { ...color, title: newTitle, description: newDescription }
          : color
      );

      shopRepository.updateCardColors(shopId, updatedCardColors).then(() => {
        showSuccessToast(
          "Color Updated",
          "The color details have been updated successfully."
        );
        syncWithSource();
      });
    }
  };

  return (
    <div className="flex max-w-96 flex-col gap-4">
      <ColorList colors={colorsArray} onEdit={handleSaveColor} />
    </div>
  );
};
